<template>
  <div id="userGoals" v-if="computedGoals.length > 0">
    <h5>{{$t('message.labelMyGoals')}}</h5>
    <div class="goal" v-for="(goal, index) in computedGoals" :key="`goal-${index}`" v-tooltip.bottom="goal.goal">
      <img :src="'static/goals/' + goal.icon + '.png'" />
    </div>
  </div>
</template>

<script>
  import ProfileMixin from "../../../mixins/ProfileMixin/index";
  import _ from "lodash";
  export default {
    name: 'profile-goals',
    mixins: [
      ProfileMixin
    ],
    data() {
      return {

      }
    },
    computed: {
      computedGoals() {
        let self = this,
            store = self.getProfile();
        return store.goals;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ProfileGoals.vue?38600fe8